import {IColorChangeable} from '../../Interfaces';

declare let THREE: any;

export class Mesh extends (THREE.Line as { new(geomerty, material): any; }) implements IColorChangeable {

  static readonly Name = 'Arc';

  constructor() {
    const geometry = new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()]);
    const material = new THREE.LineBasicMaterial({color: 0x000000, side: THREE.DoubleSide});
    super(geometry, material);
    this.name = Mesh.Name;
  }

  setColor(color): void {
    this.material.color.copy(color);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Arc/Mesh.ts